// The sign vector PNGs are chosen at runtime by MZL number or sign code, which
// Vite cannot resolve from a dynamic import path. Glob the directory up front
// so every file gets a hashed URL in the build, then look it up by name.
const signVectors = import.meta.glob('@/assets/signVectors/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

const byFileName = new Map(
  Object.entries(signVectors).map(([path, url]) => [
    path.split('/').pop() as string,
    url,
  ])
);

/**
 * URL of the sign vector image for a sign code or MZL number, or an empty
 * string when the sign has no image.
 */
export default function signVectorUrl(code: string | number): string {
  return byFileName.get(`${code}.png`) ?? '';
}
